export default "__VITE_ASSET__7fd5adba__"